//@ts-nocheck
import React, {
  createContext,
  useContext,
  useLayoutEffect,
  useState,
} from "react";
import { I18n, I18nType } from "./Core";

const I18nextContext = createContext<{ version: number; i18n: I18nType }>(null);

const { Provider } = I18nextContext;

export const I18nProvider: React.FC = ({ children }) => {
  const [updater, setUpdater] = useState(0);
  useLayoutEffect(() => {
    I18n.updater = () => setUpdater((f) => f + 1);
  }, []);
  return (
    <Provider value={{ version: updater, i18n: I18n }}>{children}</Provider>
  );
};

export const useTranslate = () => {
  const { i18n: localizer } = useContext(I18nextContext);

  return {
    t: (path: string, obj?: any) => localizer.translate(path, obj),
    i18n: localizer,
  };
};
